import { render, staticRenderFns } from "./detalhe_noticia.vue?vue&type=template&id=6fe3fee6&"
import script from "./detalhe_noticia.vue?vue&type=script&lang=js&"
export * from "./detalhe_noticia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports